// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"tg-z","categoryName":"ug-z","categoryImage":"vg-z","categoryContent":"wg-z","bottomAligned":"xg-z"};